/**
 * Aprobación de Ausencias (ASIS-5363) — mappers
 * Transport DTOs → internal UI models.
 */

import type {
  AbsenceApprovalCounters,
  AbsenceApprovalCuts,
  AbsenceApprovalMonthlyCut,
  AbsenceApprovalPage,
  AbsenceApprovalRow,
  LC_AbsenceApprovalCountersOut,
  LC_AbsenceApprovalItemOut,
  LC_AbsenceApprovalMonthlyCutItemOut,
  LC_GetAbsenceApprovalMonthlyCutsListOut,
  LC_ListAbsenceApprovalListOut,
} from './absenceApproval.types';


const EMPTY_HOUR_VALUE = { hhmmss: '00:00:00', decimalValue: 0 };

const mapMonthlyCut = (
  cut: LC_AbsenceApprovalMonthlyCutItemOut,
): AbsenceApprovalMonthlyCut => ({
  monthlyCutId: cut.monthlyCutId,
  companyId: cut.companyId,
  year: cut.year,
  month: cut.month,
  monthName: cut.monthName,
  description: cut.description,
  isClosed: cut.isClosed,
  appliesToAllCompanies: cut.appliesToAllCompanies,
});

export const mapAbsenceApprovalCuts = (
  out: LC_GetAbsenceApprovalMonthlyCutsListOut,
): AbsenceApprovalCuts => ({
  monthlyCuts: (out.monthlyCuts ?? []).map(mapMonthlyCut),
  defaultMonthlyCutId: out.defaultMonthlyCutId ?? null,
  cutsSource: out.cutsSource ?? 'none',
});

const mapRow = (item: LC_AbsenceApprovalItemOut): AbsenceApprovalRow => ({
  id: item.employeeId,
  rut: item.rut,
  employeeName: item.employeeName,
  calculatedHours: item.calculatedHours ?? EMPTY_HOUR_VALUE,
  approvedHours: item.approvedHours ?? EMPTY_HOUR_VALUE,
  status: item.status,
});

export const mapAbsenceApprovalPage = (
  out: LC_ListAbsenceApprovalListOut,
): AbsenceApprovalPage => ({
  items: (out.items ?? []).map(mapRow),
  totalRecords: out.pagination?.totalRecords ?? 0,
  isMonthlyCutClosed: out.isMonthlyCutClosed ?? false,
  isRecalculating: out.isRecalculating ?? false,
});

export const mapAbsenceApprovalCounters = (
  out: LC_AbsenceApprovalCountersOut,
): AbsenceApprovalCounters => ({
  calculated: out.calculatedHours ?? EMPTY_HOUR_VALUE,
  pending: out.pendingHours ?? EMPTY_HOUR_VALUE,
  approved: out.approvedHours ?? EMPTY_HOUR_VALUE,
  notApproved: out.notApprovedHours ?? EMPTY_HOUR_VALUE,
});
